<template>
	<section class="other_page_banner trade_sec banner_nxt_sec_not_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h2>
							{{
								$t(
									'new_ui.personal_exchange_page.section_banner.main_title.one',
								)
							}}<br />
							{{
								$t(
									'new_ui.personal_exchange_page.section_banner.main_title.two',
								)
							}}
						</h2>
						<h6>
							{{
								$t('new_ui.personal_exchange_page.section_banner.sub_title.one')
							}}
							<span>{{
								$t('new_ui.personal_exchange_page.section_banner.sub_title.one')
							}}</span>
						</h6>
						<p>
							{{
								$t('new_ui.personal_exchange_page.section_banner.paragraph.one')
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2 text-center">
					<div class="ban_rt">
						<img style="width: 80%" :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="exchng_wallet">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="exchng_wallet_btm exch_symbol_mob">
						<img :src="img.image7" alt="Logo" />
					</div>
					<div class="exchng_wallet_inn">
						<span>{{
							$t('new_ui.personal_exchange_page.exchng_wallet.title')
						}}</span>
						<h4>
							{{
								$t('new_ui.personal_exchange_page.exchng_wallet.sub_title.one')
							}}
							<span>{{
								$t('new_ui.personal_exchange_page.exchng_wallet.sub_title.two')
							}}</span>
						</h4>
						<p>
							{{
								$t('new_ui.personal_exchange_page.exchng_wallet.paragraph.one')
							}}
						</p>
					</div>
					<div class="exch_symbol_desk">
						<div class="exchng_wallet_btm">
							<div class="exchng_wallet_btm_lt text-end">
								<img :src="img.image4" alt="Logo" />
							</div>
							<div class="exchng_wallet_btm_mid">
								<img :src="img.image6" alt="Logo" />
							</div>
							<div class="exchng_wallet_btm_lt">
								<img :src="img.image5" alt="Logo" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="question_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-4 question_desk">
					<div class="question_lt">
						<img :src="img.image3" alt="" />
					</div>
				</div>
				<div class="col-sm-4 question_mob">
					<div class="question_lt">
						<img :src="img.image8" alt="" />
					</div>
				</div>
				<div class="col-sm-8">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{
								$t('new_ui.personal_exchange_page.question_sec.title')
							}}</span>
							<div class="payment_world_txt">
								<h4>
									{{
										$t(
											'new_ui.personal_exchange_page.question_sec.sub_title.one',
										)
									}}<span>{{
										$t(
											'new_ui.personal_exchange_page.question_sec.sub_title.two',
										)
									}}</span>
								</h4>
								<p>
									{{
										$t('new_ui.personal_exchange_page.question_sec.paragraph')
									}}
								</p>
								<div class="starting_to_btn pay_world">
									<a href="/auth/register">{{
										$t(
											'new_ui.personal_exchange_page.question_sec.cta_buttons.one',
										)
									}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="online_mid">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 border_dash">
					<div class="row">
						<div class="col-sm-6 order-2 order-md-1">
							<div class="business_anywhere_lt">
								<span>{{
									$t('new_ui.personal_exchange_page.online_mid.label')
								}}</span>
								<div class="business_anywhere_txt">
									<h4>
										{{
											$t('new_ui.personal_exchange_page.online_mid.title.one')
										}}
										<span>{{
											$t('new_ui.personal_exchange_page.online_mid.title.two')
										}}</span>
										{{
											$t('new_ui.personal_exchange_page.online_mid.title.three')
										}}
									</h4>
									<p>
										{{
											$t('new_ui.personal_exchange_page.online_mid.paragraph')
										}}
									</p>
									<div class="starting_to_btn">
										<a href="/auth/register">{{
											$t(
												'new_ui.personal_exchange_page.online_mid.cta_buttons.one',
											)
										}}</a>
									</div>
								</div>
							</div>
						</div>
						<div class="col-sm-6 order-1 order-md-2">
							<div class="business_anywhere_rt">
								<img :src="img.image2" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.personal_exchange_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.personal_exchange_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_exchange_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.personal_exchange_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.personal_exchange_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.personal_exchange_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.personal_exchange_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import exchangeban from '@/assets/images/sub/exchange_ban.png';
import e1 from '@/assets/images/sub/e1.png';
import exchngdiagram from '@/assets/images/sub/exchng_diagram.png';
import exchngl1 from '@/assets/images/sub/exch_logo1.png';
import exchngl2 from '@/assets/images/sub/exch_logo2.png';
import exchngl3 from '@/assets/images/sub/exchng_mid.png';
import exchngl4 from '@/assets/images/sub/exc_symbol_mob.png';
import acctmobdia from '@/assets/images/sub/acct_mob_dia.png';

export default {
	data: () => {
		return {
			img: {
				image1: exchangeban,
				image2: e1,
				image3: exchngdiagram,
				image4: exchngl1,
				image5: exchngl2,
				image6: exchngl3,
				image7: exchngl4,
				image8: acctmobdia,
			},
		};
	},
};
</script>
